import React from 'react';

export default function Heading() {
    return (
        <header className="title-container">
            <div className="text-container">
                <span>M</span>
                <span>E</span>
                <span>M</span>
                <span>O</span>
                <span>R</span>
                <span>Y</span>
                <br></br>
                <span>C</span>
                <span>A</span>
                <span>R</span>
                <span>D</span>
                <br></br>
                <span>G</span>
                <span>A</span>
                <span>M</span>
                <span>E</span>
            </div>
        </header>
    )
}